import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsEnum, IsNumber, IsOptional, IsString } from '../../validators';
import { TAchievementId } from '../achievements/achievements.registry';
import { BasicEntity } from '../basic/basic.entity';

import { EDailyRewardType } from './daily-reward.enums';

@Index(['userId', 'dayKey'], { unique: true })
export class DailyRewardClaim extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  dayIndex: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  dayKey: number;

  @ApiProperty()
  @IsEnum(EDailyRewardType, { groups: ['error'] })
  @Column({ type: 'varchar', enum: EDailyRewardType, nullable: false })
  rewardType: EDailyRewardType;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  coins: number;

  @ApiProperty()
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  achievementId?: TAchievementId | null;
}
